import React from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { useTheme } from "../../../utils/ThemeContext";
import { icons } from "../../../constants";

const MultiSelectOptions = ({
  selectedOptions,
  setSelectedOptions,
  options,
  // When every option is on, clicking one keeps only that one instead of
  // turning it off — "show just X" in one click rather than unticking the rest.
  soloWhenAllSelected = false,
}) => {
  const toggleOption = (key) => {
    const allSelected =
      options.length > 1 &&
      options.every((option) => selectedOptions.includes(option.key));
    if (soloWhenAllSelected && allSelected) {
      setSelectedOptions([key]);
    } else if (selectedOptions.includes(key)) {
      setSelectedOptions(selectedOptions.filter((v) => v !== key));
    } else {
      setSelectedOptions([...selectedOptions, key]);
    }
  };

  const getColor = (key) => {
    if (key === "odobren" || key === "odobreniSvi") return "var(--Green-box)";
    if (key === "odbijen" || key === "odbijeniSvi") return "var(--Red-box)";
    if (key === "u_obradi" || key === "ostali") return "var(--Yellow-box)";
    if (key === "prijavljen") return "var(--Purple-box)";
    return "var(--Yellow-box)";
  };

  return (
    <div className="flex-direction-column multi-select-options">
      {options.map((option, index) => {
        const isSelected = selectedOptions.includes(option.key);
        return (
          <div
            key={option.key}
            onClick={() => toggleOption(option.key)}
            className="flex-direction-row gap-6 items-center pointer width-100 multi-select-option"
            style={{
              borderRadius: index === options.length - 1 ? "0 0 8px 8px" : "0",
            }}
          >
            <div className="flex-direction-row items-center gap-4">
              <div
                style={{
                  backgroundColor: selectedOptions.includes(option.key)
                    ? getColor(option.key)
                    : "transparent",
                  border: selectedOptions.includes(option.key)
                    ? "none"
                    : "1px solid #ccc",
                }}
                className="multi-select-option-color"
              />
            </div>
            <p
              className="inria-sans-400 font-12"
              style={{ textTransform: "capitalize" }}
            >
              {option.value}
            </p>{" "}
          </div>
        );
      })}
    </div>
  );
};

export default MultiSelectOptions;
